import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { addDoctorRanks, updateDoctorRanks } from '../../actions/userActions/doctorRankAction'
import Loader from '../subComponents/Loader'
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import doctorRankIcon from "../../assets/images/Icon=Doctor Ranks.svg";
import closeModal from "../../assets/images/closeModal.svg";
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import { IconButton } from '@mui/material';
import Textarea from '../designSystem/TextArea';
import TextField from '../designSystem/TextField';
import { validateFields } from '../../utils/Validations';
function AddDoctorRanks({ onClose, editData, onSave }) {

    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const initialValues = { name: "", description: "", active: false,};
    const [formValues, setFormValues] = useState(initialValues);
    const [formErrors, setFormErrors] = useState({});
 useEffect(() => {
        if (editData) {
          setFormValues(editData);
        }
      }, [editData]);
    
      const handleChange = (event) => {
        const { name, checked, type, value } = event.target;
        setFormValues((prevValues) => ({
          ...prevValues,
          [name]: type === 'checkbox' ? checked : value,
        }));
      };

      const handleSave = (e) => {
        e.preventDefault();
     const errors =validateFields(formValues, 'doctordesignation');
        setFormErrors(errors);
    
        if (Object.keys(errors).length === 0) {
          if (editData) {
            dispatch(updateDoctorRanks(formValues));
          } else {
            dispatch(addDoctorRanks(formValues));
          }
          onSave(formValues);
        }
      };

    return (
        <>
           <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container">
        <div className="dynamicmodal-header mb-3">
          <div className="dynamicmodal-header-left">
            <div className="icon">
              <img src={doctorRankIcon} alt="doctorRankIcon" />
            </div>
            <div className="text">
              <BodyLargeMedium
                text={editData ? "Edit Doctor Designation" : "Add Doctor Designation"}
                color="#384153"
              />
              <p>Specify a new doctor designation.</p>
            </div>
          </div>
          <div className="dynamicmodal-header-right">
          <IconButton onClick={onClose}>
            <img src={closeModal} alt="" />
            </IconButton>
              </div>
         
        </div>
       

        <form onSubmit={handleSave}>
          <div className="dynamicmodal-body">
       
        <TextField
         name="name"
                    label="Name"
                      type='text'
                    value={formValues.name}
                    onChange={handleChange}
                    placeholder='Enter name'
                    error={formErrors.name}
                />
         
              <Textarea
               name="description"
        label="Description"
        placeholder="Enter your description here"
        value={formValues.description}
        onChange={handleChange}
        error={formErrors.description}
      />
   <div className=" mt-2 ml-0">
                <div
                  className="form-group"
                  style={{ display: "flex", alignItems: "flex-start" }}
                >
                  <input
                    name="active"
                    style={{ cursor: "pointer", height: "14px", width: "14px" }}
                    type="checkbox"
                    checked={formValues.active}
                    className="ml-1 mt-1"
                    onChange={handleChange}
                  />
                  <label
                    style={{ paddingLeft: "5px" }}
                    className="form-control-label"
                  >
                    <div  style={{  padding :'2px'}}>
                    <BodyExtraSmallMedium text="Active ?" color="#1E293B" />
                    </div>
  </label>
                </div>
              </div>
          </div>

          <div className="dynamicmodal-footer">
            <button
              className="cancel-button"
              type="button"
              onClick={onClose}
            >
              <BodyExtraSmallMedium color="#1E293B" text="Cancel" />
            </button>
            <button
              type="submit"
              className="primary-button"
              disabled={false}
            >
              <BodyExtraSmallMedium  color="#FFFFFF" text="Save" />
            </button>
          </div>
        </form>
      </div>
    </div>
        </>
    )
}

export default AddDoctorRanks
